import { configure } from 'mobx';
import { createBridgeComponent } from '@module-federation/bridge-react/v19';
import App from './App';

configure({ enforceActions: 'never', isolateGlobalState: true });

export default createBridgeComponent({
  rootComponent: App,
});
